<template>
  <svg
    :height="height"
    :width="computedWidth"
    alt="Logo"
    fill="none"
    viewBox="0 0 138 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="colorsComputed.start"
      d="m94.4 13.3c1.8 0 2.9-0.1 3.5-0.1 2.1 0 3.8-0.4 4.8-1.1s1.5-1.8 1.5-3.2-0.5-2.5-1.5-3.2-2.6-1.1-4.7-1.1h-6.9v0.3h0.6c0.6 0 1.1 0.1 1.4 0.4 0.3 0.4 0.4 0.9 0.4 1.5v11.4c0 0.7-0.1 1.1-0.4 1.4s-0.8 0.4-1.5 0.4h-0.6v0.3h5.7v-0.3h-0.6c-0.7 0-1.2-0.1-1.5-0.4s-0.4-0.7-0.4-1.4v-5c0.1 0 0.2 0.1 0.2 0.1zm-0.2-6.4c0-0.6 0.1-1.1 0.5-1.5s0.8-0.5 1.5-0.5h2.1c1.4 0 2.5 0.2 3.3 0.7 1.1 0.6 1.6 1.8 1.6 3.3s-0.6 2.6-1.8 3.3c-1 0.6-2.1 0.9-3.6 0.9-0.7 0-1.8-0.1-3.2-0.1h-0.2l-0.2-6.1z"
    />
    <path
      :fill="colorsComputed.start"
      d="m125.3 18c0.4 0.6 0.7 1 0.7 1.3s-0.1 0.5-0.4 0.7c-0.2 0.1-0.6 0.1-1 0.1h-0.7v0.3h5.9v-0.3c-0.7 0-1.4-0.2-2-0.6-0.5-0.4-1-0.9-1.5-1.7l-4.3-6 3.2-4.5c0.6-0.9 1.1-1.5 1.5-1.8 0.5-0.4 1.2-0.6 2-0.7v-0.2h-5.2v0.3c0.5 0 0.9 0.1 1.2 0.2 0.4 0.1 0.6 0.5 0.5 0.9 0 0.4-0.2 1-0.6 1.5l-2.9 4.1-3.2-4.5c-0.2-0.3-0.4-0.6-0.5-0.8s-0.2-0.4-0.2-0.5c0-0.3 0.1-0.5 0.4-0.6 0-0.2 0.3-0.2 0.7-0.2h0.6v-0.3h-5.2v0.3c0.7 0 1.2 0.1 1.6 0.4 0.4 0.2 0.8 0.7 1.3 1.5l3.8 5.4-3.9 5.5c-1.1 1.5-2.3 2.4-3.6 2.4v0.3h5.4v-0.3c-0.7 0-1.2-0.1-1.5-0.2-0.4-0.1-0.7-0.4-0.7-0.7 0-0.1 0.1-0.4 0.2-0.6s0.3-0.5 0.6-0.9l3.8-5.2c-0.1-0.1 4 5.4 4 5.4z"
    />
    <path
      :fill="colorsComputed.start"
      d="m46.5 18.8c0.8 0.7 1.6 1.3 2.4 1.5 0.7 0.2 1.5 0.4 2.4 0.4 1.5 0 2.7-0.4 3.6-1.2 1-0.7 1.5-1.8 1.5-3.1 0-1.5-0.6-2.7-1.7-3.5-0.6-0.4-1.8-0.9-3.8-1.5-1.7-0.5-2.7-0.9-3.1-1.1-1.2-0.6-1.8-1.5-1.8-2.6 0-1 0.4-1.9 1.3-2.5 0.7-0.5 1.6-0.7 2.7-0.7 1.5 0 2.8 0.4 3.7 1.4 0.7 0.7 1.3 1.9 1.8 3.4h0.2v-5h-0.4l-0.9 1.8-0.2-0.2c-1.2-1.2-2.6-1.8-4.3-1.8-1.3 0-2.4 0.4-3.2 1.1s-1.3 1.6-1.3 2.8 0.5 2.1 1.6 2.9c0.7 0.4 1.8 1 3.5 1.5 1.8 0.6 2.9 1 3.4 1.3 1.2 0.7 1.8 1.8 1.8 3.1 0 1.1-0.5 2-1.5 2.7-0.9 0.6-1.8 0.9-2.9 0.9-3.1 0-5.2-1.8-6-5.5l-0.2 0.1v5.5h0.3l1-1.9c-0.1 0.1 0.1 0.2 0.1 0.2z"
    />
    <path
      :fill="colorsComputed.start"
      d="m69.9 18.8c0.8 0.7 1.6 1.3 2.4 1.5 0.7 0.2 1.5 0.4 2.4 0.4 1.5 0 2.7-0.4 3.6-1.2 1-0.7 1.5-1.8 1.5-3.1 0-1.5-0.6-2.7-1.7-3.5-0.6-0.4-1.8-0.9-3.8-1.5-1.8-0.4-2.8-0.8-3.2-1-1.2-0.6-1.8-1.5-1.8-2.6 0-1 0.4-1.9 1.3-2.5 0.7-0.5 1.6-0.7 2.7-0.7 1.5 0 2.8 0.4 3.7 1.4 0.7 0.7 1.3 1.9 1.8 3.4h0.2v-5h-0.4l-0.9 1.8-0.2-0.3c-1.2-1.2-2.6-1.8-4.3-1.8-1.3 0-2.4 0.4-3.2 1.1s-1.3 1.6-1.3 2.8 0.5 2.1 1.6 2.9c0.7 0.4 1.8 1 3.5 1.5 1.8 0.6 2.9 1 3.4 1.3 1.2 0.7 1.8 1.8 1.8 3.1 0 1.1-0.5 2-1.5 2.7-0.9 0.6-1.8 0.9-2.9 0.9-3.1 0-5.2-1.8-6-5.5h-0.2v5.5h0.3l1-1.9 0.2 0.3z"
    />
    <path
      :fill="colorsComputed.start"
      d="m100.4 23.3h1v3.1l2.5-3.1h1.1l-3.7 4.5v2h-1l0.1-6.5zm2 3 0.6-0.8 2.4 4.3h-1.1l-1.9-3.5z"
    />
    <path
      :fill="colorsComputed.start"
      d="m106.4 27.4c0-1.6 1.2-2.6 2.5-2.6 1.4 0 2.2 0.9 2.2 2.3v0.5h-4v-0.6h3.4l-0.2 0.2c0-1.1-0.5-1.6-1.3-1.6-0.9 0-1.6 0.6-1.6 1.8s0.8 1.8 1.8 1.8c0.5 0 1-0.2 1.4-0.4l0.3 0.6c-0.5 0.3-1.2 0.6-1.9 0.6-1.4 0-2.6-1-2.6-2.6z"
    />
    <path
      :fill="colorsComputed.start"
      d="m112.9 25h0.8l0.1 0.8c0.5-0.5 1-0.9 1.8-0.9 1.1 0 1.7 0.7 1.7 2v3h-1v-2.9c0-0.9-0.3-1.2-1-1.2-0.5 0-0.9 0.3-1.4 0.8v3.4h-1v-5z"
    />
    <path
      :fill="colorsComputed.start"
      d="m119 31.8 0.2-0.8c0.1 0 0.3 0.1 0.4 0.1 0.7 0 1-0.4 1.3-0.9l0.1-0.3-2.2-4.9h1l1.1 2.5c0.2 0.4 0.4 0.9 0.6 1.4 0.2-0.5 0.3-1 0.5-1.4l1-2.5h1l-2.1 5.2c-0.4 1-1 1.7-2.1 1.7-0.4 0-0.7 0-0.8-0.1z"
    />
    <path
      :fill="colorsComputed.start"
      d="m125.3 28.6c0-1.1 1-1.6 3.5-1.8 0-0.6-0.4-1.1-1.2-1.1-0.6 0-1.2 0.3-1.7 0.5l-0.4-0.7c0.5-0.3 1.4-0.7 2.2-0.7 1.3 0 2 0.8 2 2.1v2.9h-0.8l-0.1-0.6c-0.5 0.4-1.2 0.8-1.9 0.8-0.9 0-1.6-0.6-1.6-1.4zm3.5-0.1v-1.1c-1.9 0.1-2.5 0.5-2.5 1.1 0 0.5 0.4 0.7 1 0.7 0.4 0 0.9-0.3 1.5-0.7z"
    />
    <path
      :fill="colorsComputed.start"
      d="m24.1 12.3c-0.9-0.5-1.7-0.7-2.4-0.7-0.3 0-0.4 0-0.7 0.1-0.2 0.1-0.4 0.1-0.6 0.2l-0.6 0.3c-1 0.6-1.3 1.3-1.3 1.4l-0.1 0.3-0.3-0.1c-0.3-0.1-0.5-0.1-0.7-0.1-0.4 0-0.8 0.1-1.2 0.3 0.8 0.6 1.3 1.2 1.6 1.6 0.2-0.3 0.6-0.6 1-1.1 0.8-0.7 1.8-1.4 3-1.4 0.6 0 1.2 0.2 1.9 0.6 1.2 0.9 1.5 2.2 1.5 3.6 0 2.2-0.9 4.4-1.5 5.3-0.1 0.1-1.9 3.5-5.7 6.3l-0.1 0.1h-0.3l-0.1-0.1c-3.8-2.8-5.7-6.2-5.7-6.3-0.5-0.9-1.4-3.1-1.4-5.3 0-1.3 0.4-2.7 1.5-3.6 0.5-0.4 1-0.6 1.5-0.6 0.2-0.2 0.8-0.8 1.5-1.3-0.4-0.1-0.8-0.2-1.2-0.2-0.7 0-1.5 0.2-2.4 0.6-2.1 1.2-2.5 3.5-2.5 5.2 0 0.5 0.1 1 0.1 1.3 0.1 0.3 0.1 0.5 0.1 0.5s0 0.1 0.1 0.3 0.1 0.4 0.2 0.8c0.2 0.6 0.6 1.6 1.2 2.8 1.2 2.2 3.3 5.1 7.3 7.6 6.9-4.5 8.3-9.9 8.6-11.1 0.1-0.2 0.1-0.3 0.1-0.3s0-0.3 0-0.7c0.1-0.3 0.1-0.8 0.1-1.3 0-1.5-0.4-3.9-2.5-5m-7.6-0.6h0.1v-0.1c0 0.1 0 0.1-0.1 0.1"
    />
    <path
      :fill="colorsComputed.start"
      d="m21.5 13.7c-0.5 0.1-1 0.3-1.4 0.6 0.7 0.8 0.9 1.9 0.9 3 0 2.2-0.9 4.4-1.5 5.3-0.1 0.2-1.2 2.1-3.3 4.2 0.3 0.3 0.6 0.6 1 0.9 3.8-3.7 4.8-7.3 5-8.3 0.1-0.2 0.1-0.3 0.1-0.3s0.1-0.2 0.1-0.5c0.1-0.3 0.1-0.8 0.1-1.3-0.1-1-0.3-2.4-1-3.6m-7.7 15.2-0.3 0.1-0.1-0.1c-3.7-2.8-5.6-6.2-5.7-6.3-0.5-0.9-1.4-3.1-1.5-5.3 0-1.3 0.4-2.7 1.5-3.6 0.6-0.4 1.2-0.6 1.9-0.6h0.1c0.4-0.4 0.8-0.9 1.3-1.2-0.4-0.1-0.9-0.3-1.4-0.3-0.7 0-1.5 0.2-2.4 0.7-2.1 1.2-2.5 3.5-2.5 5.2 0 0.5 0.1 1 0.1 1.3s0.1 0.5 0.1 0.5 0 0.1 0.1 0.3 0.1 0.4 0.2 0.8c0.2 0.6 0.6 1.6 1.2 2.8 1.2 2.2 3.3 5.1 7.3 7.6 0.6-0.4 1.1-0.8 1.6-1.2-0.4-0.3-0.7-0.6-1-0.9-0.3 0-0.4 0-0.5 0.2m-1.5-14.7c0.1 0.1 0.2 0.1 0.3 0.2 0.4 0.4 0.8 0.8 1 1.1 0.2-0.3 0.6-0.6 1-1.1l0.3-0.3c0.3-0.3 1.2-1.2 2.4-1.2 0.2 0 0.4 0 0.6 0.1 0.1-0.3 0.4-0.8 1-1.2-0.6-0.2-1-0.3-1.5-0.3-0.3 0-0.4 0-0.7 0.1-1 0.2-2.2 1.2-2.7 1.7l-0.3 0.3h-0.3c-0.2 0.2-0.7 0.3-1.1 0.6"
    />
    <path
      :fill="colorsComputed.start"
      d="m22 6.1-0.5 1.6-1.8-0.4 0.3-1.7-1.4-0.3-0.3 1.7-2.1-0.1v-3.3h1.4v-1h-1.4v-1.5h-1.1v1.5h-1.5v1.2h1.6v3l-2.2 0.2-0.3-1.7-1.4 0.2 0.3 1.8-1.8 0.5-0.5-1.7-1.4 0.7 1.6 4.2h0.2c0.5 0 1 0.1 1.5 0.3-0.2-0.5-0.4-1.2-0.8-2.1l-0.1-0.3 0.3-0.1c1.8-0.6 3.6-0.8 5.1-0.8 3 0 5.2 0.8 5.2 0.8l0.3 0.1-1 2.5c0.4-0.2 1-0.3 1.6-0.3h0.1l1.5-4.2-1.4-0.8z"
    />
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useTheme } from '../composables/useTheme'

interface Props {
  width?: number | string
  height?: number | string
  start?: string // For backward compatibility
  stroke?: string
  strokeWidth?: number
  textColor?: string
}

const props = withDefaults(defineProps<Props>(), {
  width: undefined,
  height: 75,
  start: '', // Will use brand color if not provided
  stroke: 'transparent',
  strokeWidth: 0,
  textColor: '#ffffff',
})

const { getBrandColor } = useTheme()

const computedColor = computed(() => {
  // Use the start prop for backward compatibility if provided
  if (props.start) {
    return props.start
  }

  // getBrandColor() now automatically returns the correct color for light/dark mode
  return getBrandColor()
})

const computedWidth = computed(() => {
  if (props.width !== undefined) {
    return props.width
  }
  // Auto-calculate width based on height to maintain aspect ratio
  const aspectRatio = 138 / 32 // viewBox ratio
  return typeof props.height === 'number' ? props.height * aspectRatio : 100
})

const colorsComputed = computed(() => {
  return {
    start: computedColor.value,
  }
})
</script>
